import { css } from "@emotion/react";


export const emotionGlobalCss = css`
  body{
    margin: 0;
  }

  a{
    text-decoration: none;
  }
  
  
  .header-container{
   display: grid;
   grid-template:
  
   "headerMain" 80px
   "navBar" 40px
   "bottomHeader" 50px;
   /* position: fixed; */
    top: 0;
    width: 100%;
    background-color: white ;
    z-index: 999 ;
    position: relative !important;
  
   /* padding: 0 3%; */
  
  }
  
  .subMenuItems{
    color:#222;
    text-decoration:none;
    font-weight: bold;
  }
  
  
  .headerMain{
    grid-area: headerMain;
    display: grid;
    padding-top:5px;
    grid-template: ". logoArea widgetContainer ." / 3% 300px auto 2%;
  }
  
  .logoArea{
    grid-area: logoArea;
  }
  
  .logoArea img{
    height: 70px;
  
  
  }
  
  .widgetContainer{
    grid-area: widgetContainer;
  justify-self: end;
  width: 300px;
   /* text-align: right; */
   /* position: relative;
   right: 0px;
   top: 0px; */
  }
  
  
  
  
  .navbar{
    grid-area: navBar;
   /* border-bottom: 16px solid #222; */
  display: grid;
  grid-template: ". menu . menuCta ." / 2% 600px auto 306px 2%;
  position: relative;
  background-color: #222;
  z-index: 1;
  /* align-items: center; */
  
  }
  .navbar input{
    display: none;
    margin-top: 14px;
  }
  
  .burgerMenu{
    display: none;
  }
  
  .menu{
    grid-area: menu;
    display: grid;
    /* padding-right: 3%; */
    /* grid-auto-flow: column; */
  grid-template-columns: repeat(auto-fit, minmax(max-content , 100px));
    /* grid-template: minmax(conte) */
    /* grid-template-columns: auto; */
    /* justify-items: center;
    align-items: center; */
    height: 40px;
    /* border-radius: 10px 10px 0 0; */
    margin: 0;
    padding: 0;
  
  }
  .menuItem{
    align-self: center;
    list-style: none;
    vertical-align: middle;
  }
  
  .menuItem:hover{
    border-radius: 10px 10px 0 0;
    background-color: black;
  }
  
  .menuItem a{
    text-decoration: none;
    padding: 0 20px;
    /* padding-bottom: 10px; */
    color:white;
    vertical-align: middle;
    font-family: Gotham Medium,"M Hei PRC W45","M Hei HK W42","M Hei HK W40","HelveticaNeue-Regular","Helvetica Neue Regular","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-weight: bold;
  }
  
  
  
    /* text-align: center; */
  
  .roundLogo{
    display: none;
  }
  
  .menuItem span{
    vertical-align: middle;
  }
  
  .home{
    color: #666;
  }
  
  .menuItem a:hover{
    color: #70c000;
  }
  .menuCtaRound{
    margin-top: -9px;
    margin-right: 19px;
  }
  
  
  .menuCta{
    grid-area: menuCta;
    position: relative;
    top: -7.5px;
    height: 50px !important;
  }
  .sticky .burgerMenuModule {
    top: 0px!important;
  }
  .sticky .menuCtaRound {
    margin-top: 1px;
    margin-right: 5px;
}
  
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .navbar {
      display: -ms-flexbox;
    }
    .menu {
      display: -ms-flexbox;
    }
    .menuCta {
      display: -ms-flexbox;
      margin-left: auto;
      margin-right: 5vw;
    }
    .headerMain, .widgetContainer {
      display: -ms-flexbox;
    }
    .widgetContainer {
      margin-left: auto;
      margin-right: 88px;
    }
    .inlineBlock {
      visibility: hidden;
    }
   
    .selectors .react-dropdown-select {
      display: inline-block;
    }
    .selectors .react-dropdown-select .react-dropdown-select-content {
      display: inline !important;
    }
    .selectors .react-dropdown-select .react-dropdown-select-dropdown-handle {
      display: inline;
    }
    .selectors {
      padding-top: 15px;
    }
    .menuCta .gatsby-image-wrapper {
      height: 60px !important;
    }
    .allBenefits .theBenefit {
      padding: 10px 0px !important;
    }
    .flexFeat {
      padding: 0px;
    }
    .flexFeat .innerF {
      flex: 0 0 21%;
      padding: 2%;
    }
    
    .burgerMenuModule {
      position: absolute !important;
      left: 0px;
      top: 15px !important;
    }
  
    .logoArea {
      padding-left: 20px;
    }
  }
  
  @media only screen and (min-width: 768px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .menu {
      padding-top: 8px;
    }
  }
  
  @media only screen and (max-width: 767px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .logoArea {
      width: 100%;
      padding-left: 0px;
    }
    
    .menuCta .gatsby-image-wrapper{
      top: 0.5px !important;
    }
  }
  
  
  @media only screen and (max-width: 1023px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .navbar .menu {
      display: -ms-flexbox;
      flex-direction: column !important;
      left: 0px;
    }
  }
  
  @media only screen and (max-width: 1023px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .flexFeat .innerF, .ie .innerF {
      flex: 1 1 100%;
    }
  }
  
  @media only screen and (max-width: 1279px) and (min-width: 860px)and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .commitImage {
      background-image: url("/static/GirlHeatPumpImage-63250a7e8f5e3a8fe6d67b51a4e4b8a5.jpg");
      margin-left: -20vw;
      background-size: cover;
    }
    .energyImage {
      display:none;
    }
  }
  
  .menuCta .gatsby-image-wrapper{
    position:relative;
    height: 50px;
    top: 3.5px;
    z-index: 99999999;
    right: -5px;
  
  }
  
  .menuCta:hover{
    filter: brightness(80%)
  }
  
  .bottomHeader{
    grid-area: bottomHeader;
    background-color: #70c000;
    color: #222;
  
    display: grid;
    grid-template: "selectors" / 1fr;
    font-family:"lucida grande", tahoma, verdana, arial, sans-serif;
    font-weight: 400;
    font-size: 2rem;
    justify-items: center;
  
  
  }
  
  /* .contactNav{
    grid-area: contactNav;
    font-size: 1.5rem;
    margin: auto 0;
    color: #222;
    display: none;
  
  } */
  
  /* .contactNav a span {
    color: #222;
    font-weight: 600;
    font-size: 2rem;
  } */
  
  /* .city{
    grid-area: city;
    text-align: center;
    font-size: 1.6rem;
    margin: auto;
    font-weight: 400;
    display: none;
  } */
  
  .selectors{
    display: flex;
    justify-content: center;
    grid-area: selectors;
    font-size: 1.4rem;
    margin: auto 0;
    color: #222 !important;
    text-align: center;
  }
  
  
  .selectCity{
    display: grid;
    grid-template: "locationTag citySelector arrowSelector" / 10px 195px 10px;
    position: relative;
  }
  .locationTag{
    grid-area: locationTag;
    position: relative;
  }
  .locationTag svg{
    position: relative;
    top: 15px;
    height: auto;
    width:21px !important;
  }
  .citySelector{
    grid-area: citySelector;
    z-index: 2;
  
  }
  .arrowSelector{
    grid-area: arrowSelector;
    position: relative;
    left: -20px;
    top:15px;
    z-index: 1;
  }
  
  .selectCity select{
  
    background-color: transparent;
    -webkit-appearance: none;
    border: 0;
    padding-right: 30px;
    cursor: pointer;
    color: #222 ;
    text-align: right !important;
    font-family: Gotham Medium,"M Hei PRC W45","M Hei HK W42","M Hei HK W40","HelveticaNeue-Regular","Helvetica Neue Regular","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-weight: normal;
    font-size: 2rem;
    width: fit-content !important;
  
  }
  
  .selectLanguage{
    margin:auto 0;
    align-items: center !important;
    vertical-align: middle !important;
  
  }
  
  .selectLanguage a{
  
    margin-left: 0px ;
    padding-left: 20px ;
    border-left-width: 2px ;
    border-left-color: #222 ;
    border-left-style: solid ;
    text-decoration: none ;
    color: #222 ;
  
    font-family: Gotham Medium,"M Hei PRC W45","M Hei HK W42","M Hei HK W40","HelveticaNeue-Regular","Helvetica Neue Regular","Helvetica Neue",Helvetica,Arial,sans-serif ;
    font-weight: normal ;
    text-decoration: none ;
  }
  
  .selectors #site{
    width: 170px;
    /* text-align: right !important; */
  }
  
  
  .selectors .languageSwitch{
    color: #222 ;
  }
  
  
  
  .languageSwitch:hover{
    color: grey;
  
  }
  
  /* Sticky navBar */
  .sticky .navbar{
    grid-template: ". logo menu . menuCta ." / 2% 50px 600px auto 306px 0%;
    position: fixed;
    width: 100%;
    top:0;
    padding-top: 10px;
    border-bottom: 1px solid #70c000;
    z-index: 9;
  
  }
  
  .sticky .roundLogo{
    grid-area: logo;
    position: relative;
    display: block;
    width: 45px;
    height: auto;
    align-items: center;
    /* vertical-align: middle; */
    top:-3px;
  }
  
  .menuCtaRound{
    grid-area: menuCta;
    text-align: right;
  }
  .menuCtaRound .gatsby-image-wrapper img{
    position: relative;
    height: 45px;
    top: -43px;
  }
  .sticky .menuCta{
    grid-area: menuCta;
    display: block;
  }
  
  .sticky .menuCtaRound .gatsby-image-wrapper{
    position: relative;
    height: 45px;
    top: -4px;
  }
  
  
  @media screen and (max-width: 1023px) {
    .headerMain{
      grid-template: ". logoArea widgetContainer ." / 2% 300px auto 2%;
    }
  
    .widgetContainer{
      position: relative;
      right: -30px;
    }
  
    .navbar{
      grid-template: ". burgerMenu roundLogo menuCta ." / 2% 60px auto 306px 2% !important;
      z-index: 5;
      -webkit-user-select: none;
      user-select: none;
    }
  
    .navbar input{
      grid-area: burgerMenu;
      display: block;
      width: 40px;
      height: 32px;
      cursor: pointer;
      opacity: 0;
      z-index: 10;
  
      -webkit-touch-callout: none;
    }
  
    .navbar .burgerMenuModule{
      grid-area: burgerMenu;
      position: relative;
      top:-2px;
      margin: auto 0;
    }
  
    .navbar .burgerMenu{
      display: block;
      width: 30.499px;
      height: 4px;
      margin-bottom: 5px;
      position: relative;
      left: 10px;
      background: #cdcdcd;
      border-radius: 3px;
      z-index: 9;
      transform-origin: 4px 0px;
      transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
      background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
      opacity 0.55s ease;
    }
  
    .navbar .bar1
    {
      transform-origin: 0% 0%;
    }
  
    .navbar .bar1
    {
      transform-origin: 0% 100%;
    }
  
    .navbar input:checked ~ div .burgerMenu
    {
      opacity: 1;
      transform: rotate(45deg) translate(-2px, -1px);
    }
  
    .navbar input:checked ~ div .bar2
    {
      opacity: 0;
      transform: rotate(0deg) scale(0.2, 0.2);
    }
  
    .navbar input:checked ~ div .bar3
    {
      transform: rotate(-45deg) translate(0, -1px);
    }
  
    .menu
    {
      position: absolute;
      grid-template-columns: 1fr;
      width: 300px;
      top:40px;
      margin:0px 0 0 0px;
      padding: 0px;
      padding-bottom: 0px;
      height: 500px;
      background: #222;
      list-style-type: none;
      -webkit-font-smoothing: antialiased;
      transform-origin: 0% 0%;
      transform: translate(-100%, 0);
      transition: transform 1s cubic-bezier(0.77,0.2,0.05,1.0);
      z-index: 0;
      align-content:flex-start;
    }
  
    .menu li
    {
      padding: 10px 0;
      font-size: 22px;
    }
  
    .navbar input:checked ~ ul
    {
      transform: none;
    }
    .navbar input:checked ~ ul li{
      display: block;
    }
  
    .navbar .menuCta{
      right: -30px;
    }
  
  
  /* sticky menu */
  .sticky .navbar{
    grid-template: ". burgerMenu roundLogo menuCta ." / 2% 306px auto 306px 2% !important;
    z-index: 5;
    -webkit-user-select: none;
    user-select: none;
  }
  
  .sticky .roundLogo{
    grid-area: roundLogo;
    position: relative;
    top: -5px;
    margin: auto;
  }
  
  .sticky .menuCtaRound{
    display: block;
    grid-area: menuCta;
    text-align: right;
  }
  .sticky .menuCtaRound .gatsby-image-wrapper{
    position: relative;
    height: 45px;
    top: -3.5px;
  }
  
  .sticky .menuCtaRound .gatsby-image-wrapper:hover{
    filter: brightness(80%)
  }
  .sticky .menu{
    top:55px;
  }
  
  .sticky .menuCta{
    //display: none;
  }
  
  }
  
  @media screen and (max-width: 767px) {
    .headerMain{
      grid-template: "logoArea" / auto;
      width: 100%;
    }
    .logoArea{
      text-align: center;
    }
  
    .widgetContainer{
      width: 800px;
      height: 75px;
      bottom: 0px;
      position: fixed;
      background-color:white;
      padding-left: 270px;
      margin: 0 auto;
      padding-bottom: 5px;
      padding-top: 5px;
      left: 48%;
      margin-left: -400px;
    }
  
    .sticky .widgetContainer{
      display: none;
    }
  
    .sticky .navbar{
      grid-template: ". burgerMenu roundLogo menuCta ." / 2% 50px auto 50px 2% !important;
      z-index: 5;
      -webkit-user-select: none;
      user-select: none;
    }
  
  .menuCta{
    position: relative;
    right: 5px !important;
    top:-6px;
  }
  
  .menuCta .gatsby-image-wrapper{
    height: 45px;
  
  }
    .navbar{
      grid-template: ". burgerMenu . menuCta ." / 2% 50px auto 50px 2% !important;
    }
    .menuCtaRound .gatsby-image-wrapper{
      height:46px
  }
  
  }
  
  @media screen and (max-width: 374px) {
  
  .bottomHeader select{
    position: relative;
    font-size: 1.5rem;
  
  }
  
  .locationTag svg{
    height: 22px;
  }
  .selectCity{
    display: grid;
    grid-template: "locationTag citySelector arrowSelector" / 10px 160px 10px;
    position: relative;
  }
  .citySelector{
    position: relative;
    top:3px;
  }
  
  }
`  